import { generatePath } from 'react-router';
import { useTranslation } from 'react-i18next';
import { AddBusinessOutlined } from '@mui/icons-material';
import TrumpeterButterflyImage from '../assets/images/trumpeter_butterfly.png';
import EmptyPagePlaceholder from '../common/components/EmptyPagePlaceholder';
import { RoutePaths } from '../routes/AppRoutes';

interface WishlistEmptyStateProps {
  variant: 'product' | 'supplier';
}

export default function WishlistEmptyState({ variant }: WishlistEmptyStateProps): React.JSX.Element {
  const { t } = useTranslation(['wishlist']);

  const isSupplier = variant === 'supplier';

  return (
    <EmptyPagePlaceholder
      title={t(isSupplier ? 'wishlist:empty_suppliers_title' : 'wishlist:empty_title')}
      description={t('wishlist:empty_description')}
      imageSrc={TrumpeterButterflyImage}
      buttonLabel={t(isSupplier ? 'wishlist:discover_suppliers_cta' : 'wishlist:discover_products_cta')}
      linkDestination={generatePath(RoutePaths.DISCOVERY_SUPPLIERS)}
      buttonProps={{
        startIcon: <AddBusinessOutlined />,
      }}
      sx={{ pt: 4 }}
    />
  );
}
